import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChangeRequestConstants } from '../change-request.constants';
import { ChangeRequestItem } from '../models/change-request-item';

@Component({
  selector: 'app-approve-periodic-change-request-item-modal',
  templateUrl: './approve-periodic-change-request-item-modal.component.html',
  styleUrls: ['./approve-periodic-change-request-item-modal.component.scss']
})
export class ApprovePeriodicChangeRequestItemModalComponent implements OnInit {


  @Input() isPeriodicApprovalModal!:boolean;
  @Output() isPeriodicApprovalModalVisible=new EventEmitter<boolean>();
  approvalDescription!: string;
  @Input() selectedItems!:ChangeRequestItem[];
  errorMessages: string[] = [];
  mandatoryFields = this.getDefaultMandatoryFields();
  @Output() descriptionForPeriodicReviewApproval=new EventEmitter<string>();
  readonly periodicReviewCRIStaticMessageForModal=ChangeRequestConstants.Periodic_ReviewCRI_Static_Message_For_Approval_Modal;
  readonly errorMessageConstant=ChangeRequestConstants.error_message_constant;
  constructor() { }

  ngOnInit(): void {
  }

  cancel():void{
    this.isPeriodicApprovalModal=false;
    this.isPeriodicApprovalModalVisible.emit(this.isPeriodicApprovalModal);
  }

  getDefaultMandatoryFields() {
    return {
      approvalDescription: false,
    }
  }
  confirmPeriodcChangeRequestApproval()
  {
    this.errorMessages=[];
    this.validateRejectChangeRequestModalControls();
    if(this.errorMessages.length === 0){   
    this.descriptionForPeriodicReviewApproval.emit(this.approvalDescription);
    this.isPeriodicApprovalModal=false;
    }
  }


  private validateRejectChangeRequestModalControls(){
    if(this.approvalDescription===null || this.approvalDescription ===undefined || this.approvalDescription===''){
          this.mandatoryFields.approvalDescription = true;
          this.errorMessages.push(ChangeRequestConstants.DescriptionMandatoryErrorMessage); 
    }
  }


}
